import React, { useEffect, useState } from 'react';
import { styled } from '@abyss/web/tools/styled';
import { FindForm } from './FindForm/FindForm';

const CommonFormHeading = styled('h3', {
  fontWeight: 'bold',
  fontSize: '28px',
  marginTop: 20,
});

export const CommonForm = () => {
  const [role, setRole] = useState({});
  const roleMap = {
    'provider-service-advocate-user': {
      heading: 'Provider Service Advocate',
      adminContextRole: 'provider-service-advocate-user',
    },
    'paan-administrator-user': {
      heading: 'PAAN Administrator',
      adminContextRole: 'paan-administrator-user',
    },
  };
  useEffect(() => {
    const { hash } = window.location;
    const splitHash = hash.split('#/');
    if (splitHash.length === 2) {
      setRole(roleMap[splitHash[1]]);
    }
  }, [window.location.hash]);

  return (
    <If condition={role}>
      <CommonFormHeading>{role.heading}</CommonFormHeading>
      <p>Search for submitting provider.</p>
      <FindForm adminContextRole={role.adminContextRole} />
    </If>
  );
};
